import React from 'react';
import PropTypes from 'prop-types';
import { Price } from './price';
import getTranslatedText from '../../../helper/get_translated_text';
import { generateClassName } from '../../../../_modules/helper/generate_class_name';

const lazyClassNames = generateClassName({
    'all-items-price': true,
    'all-items-price--has-mates-rates': ({ hasMatesRates }) => hasMatesRates,
});

export const AllItemsPrice = props => (
    <Price
        name={lazyClassNames(props)}
        label={getTranslatedText('pdp-sidebar-all-items-price')}
        price={props.price}
        currencyIsoCode={props.currencyIsoCode}
    />
);

AllItemsPrice.propTypes = {
    price: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    hasMatesRates: PropTypes.bool.isRequired,
};
